<script>
import Vue from "vue"
import appConfig from "@/app.config"
import Layout from "@/views/layouts/main"
import PageHeader from "@/components/page-header"
import List from "./list"
import Insert from "./insert"
import Edit from "./edit"
import Wizard from "./wizard"
import MultiAgendasWizard from "./MultiAgendasWizard"
import Multiselect from "vue-multiselect";
import { http } from "@/helpers/easyindustriaapi/config"
import Swal from "sweetalert2"
import moment from "moment"
import atendimentoController from "@/controller/AtendimentoController"
import ReportController from "@/controller/ReportController"
import AtendimentosRealizados from "@/views/pages/relatorios/atendimentos/AtendimentosRealizados"
import {
  filterActiveProfessionals,
  isProfessionalActive,
  professionalFilterLabel,
  mapProfessionalOption,
} from "@/helpers/professionalStatus"

export default {
  page: {
    title: "Atendimentos",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { List, Insert, Edit, Wizard, MultiAgendasWizard, PageHeader, Layout, Multiselect },
  data() {
    return {
      listAgreements:[],
      listApproachs:[],
      listResponsibles:[],
      listSpecialties:[],
      listPacients:[],
      listPacientsPluck:[],
      listProfessionals:[],
      listProfessionalsPluck:[],
      listCodeTax:[],
      currentAtendimento:{},
      currentProfessional: {},
      professionals: [],
      listPrices: [],
      tiposPagamento: [],
      filtering: false,
      inserindo: false,
      editando: false,
      wizardIn: false,
      wizardMultiAgendas: false,
      titleBody: "Lista de Atendimentos",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Atendimentos",
          href: "/atendimentos",
          active: true,
        },
      ],
      atendimentos:[],
      oldAtendimentos:[],
      params: {
        professionals: null,
        pacients: null,
        agreement_id: null,
        date_ini: null,
        date_end: null
      },
      collapseVisible: false,
    };
  },
  computed: {
    isHide() {
      return !this.inserindo && !this.editando && !this.wizardIn && !this.wizardMultiAgendas;
    },
    permission() {
      // Verifica se o perfil é super ou admin no currentUser.roles
      return this.currentUser.roles.some(
        (role) => role.name === "super" || role.name === "admin"
      );
    },
  },
  created() {
    if (JSON.parse(localStorage.getItem('atendimentos_params')))
    {
      this.params = JSON.parse(localStorage.getItem('atendimentos_params'));
    }

    this.currentUser = JSON.parse(localStorage.getItem("user"));
    this.currentEmpresa = JSON.parse(localStorage.getItem("currentEmpresa"));
    this.atendimentoController = new atendimentoController(this.currentUser, this.currentEmpresa);
    this.reportController = new ReportController();
  },
  mounted() {
    this.atendimentoController.doGet(this.params ?? null).then(() => {
      this.getTable()
      this.onFilters(this.params ?? null);
    })
  },
  methods: {
    isProfessionalActive,
    professionalFilterLabel,
    doPost(atendimento) {
      Swal.fire({
        title: "Aguarde...",
        text: "Gravando dados...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        },
      })
      
      const promisse = this.atendimentoController.doPost(atendimento)
      promisse.then((response) => {
        this.showSuccess('Registro gravado com sucesso!')
        this.atendimentos = response.data
        this.onFilters(this.params ?? null)
        this.back()
      })
    },
    doPostLote(payload) {
      if (!payload.agendas || payload.agendas.length === 0) {
        this.showWarning('Adicione ao menos uma agenda.')
        return
      }
      Swal.fire({
        title: "Aguarde...",
        text: "Gravando multi-agendas...",
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading() },
      })
      this.atendimentoController
        .doPostLote(payload)
        .then((response) => {
          const data = response?.data || {}
          const createdCount = Number(data.created_count || payload.agendas.length || 0)
          const createdItems = Array.isArray(data.created_items) ? data.created_items : []
          const errors = Array.isArray(data.errors) ? data.errors : []

          let message = `${createdCount} agenda(s) criada(s) com sucesso.`
          if (createdItems.length > 0) {
            message += ` Itens confirmados: ${createdItems.length}.`
          }
          if (errors.length > 0) {
            message += ` ${errors.length} item(ns) com erro.`
          }

          if (createdCount > 0) {
            this.showSuccess(message)
          } else {
            this.showWarning(errors[0]?.message || 'Nenhuma agenda foi criada.')
          }

          if (errors.length > 0) {
            const detail = errors
              .slice(0, 5)
              .map((err, idx) => `#${idx + 1} - ${err?.message || 'Erro não especificado'}`)
              .join('\n')
            Swal.fire({
              icon: 'warning',
              title: 'Algumas agendas não foram criadas',
              text: detail,
            })
          }

          this.atendimentoController.doGet(this.params ?? null).then((getResponse) => {
            this.atendimentos = getResponse.data
            this.onFilters(this.params ?? null)
          })
          this.back()
        })
        .catch((error) => {
          Swal.close()
          const msg = error?.response?.data?.message || error?.message || 'Erro ao gravar multi-agendas.'
          this.showWarning(msg)
        })
    },
    async doPut(value) {
      Swal.fire({
        title: "Aguarde...",
        text: "Gravando dados...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading() // Exibe o loader enquanto a requisição está em andamento
        },
      })
      const atendimento = {
        ...value,
        user_id: this.currentUser.id,
        empresa_id: this.currentEmpresa.id,
        agreement_id: value.agreement_id ?? value.agreement?.id ?? null,
        pacient_id: value.pacient_id ?? value.pacient?.id ?? null,
        professional_id: value.professional_id ?? value.professional?.id ?? null,
        service_value: this.new_convert_srting_float(value.service_value),
        transfer_amount: this.new_convert_srting_float(value.transfer_amount),
        coparticipation_amount: this.new_convert_srting_float(value.coparticipation_amount),
      }

      if (value.start_date) {
        atendimento.start_date = moment(value.start_date).format("YYYY-MM-DD")
      } else if (value.start) {
        atendimento.start_date = moment(value.start).format("YYYY-MM-DD")
      }

      if (value.end_date) {
        atendimento.end_date = moment(value.end_date).format("YYYY-MM-DD")
      } else if (value.end) {
        atendimento.end_date = moment(value.end).format("YYYY-MM-DD")
      }

      if (value.start_time) {
        atendimento.start_time = moment(value.start_time, "HH:mm:ss").format("HH:mm")
      }

      if (value.end_time) {
        atendimento.end_time = moment(value.end_time, "HH:mm:ss").format("HH:mm")
      }

      delete atendimento.start
      delete atendimento.end

      try {
        const response = await http.put(
          `/atendimento/${atendimento.id}?empresa_id=${this.currentEmpresa.id}`,
          atendimento
        )

        if (response.status === 200) {
          this.onFilters(this.params ?? null)
          this.back()
          this.showSuccess("Registro alterado")
        }
      } catch (error) {
        this.showWarning(this.getErrorMessage(error, "Erro ao alterar atendimento."))
      }
    },
    async doUpdateSchedules(schedule) {
      console.log(schedule)
      Swal.fire({
        title: "Aguarde...",
        text: "Gravando dados...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading() // Exibe o loader enquanto a requisição está em andamento
        },
      })
      schedule.user_id      = this.currentUser.id
      schedule.oldDateEnd   = moment(schedule.oldDateEnd).format("yyyy-MM-DD")
      schedule.newDateStart = moment(schedule.newDateStart).format("yyyy-MM-DD")
      schedule.newTimeStart = moment(schedule.newTimeStart, "HH:mm:ss").format("HH:mm")
      schedule.newTimeEnd   = moment(schedule.newTimeEnd, "HH:mm:ss").format("HH:mm")
      let response = await http
        .put(
          "/atendimento/" + schedule.atendimentoId + "/updateSchedules?empresa_id=" + this.currentEmpresa.id,
          schedule
        )
        .catch((error) => {
          Swal.close
          this.showWarning(error.response.data)
        })

      if (response.status === 200) {
        // Toogle modal-update-schedules
        this.$bvModal.hide('modal-update-schedules')
        Swal.close()
        this.showSuccess("Atendimento reagendado com sucesso!")
      }
    },
    async finishAtendimento(finishData) {
      Swal.fire({
        title: "Aguarde...",
        text: "Encerrando atendimento...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await this.atendimentoController.finishAtendimento(
          finishData.atendimento.id,
          finishData.atendimento
        )

        if (response) {
          this.$bvModal.hide('modal-finish-atendimento')
          Swal.close()
          this.showSuccess("Atendimento encerrado com sucesso!")
          this.onFilters(this.params ?? null)
        }
      } catch (error) {
        Swal.close()
        this.showWarning(error)
      }
    },
    doDelete(atendimento) {
      this.onLoader()
      atendimento.empresa_id = this.currentEmpresa.id
      const promisse = http.delete("/atendimento/" + atendimento.id + "?empresa_id=" + this.currentEmpresa.id, atendimento)
        promisse.then((response) => {
          console.log(response.status)
          this.offLoader()

          if (response.status === 200) {
            this.showSuccess("Registro excluído com sucesso!")
            this.onFilters(this.params ?? null)
            this.back()
          }
        })
        .catch((error) => {
          this.offLoader()
          this.showWarning(error.response)
        })
    },
    async getTable() {
      Swal.fire({
        title: "Aguarde",
        text: "Carregando as tabelas...",
        allowOutsideClick: false,
        showConfirmButton:false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await http.get("/atendimento/tabelas?empresa_id=" + this.currentEmpresa.id)

        if (response.status === 200) {
          this.listApproachs      = response.data.approachs
          this.listAgreements     = response.data.agreements
          this.listCodeTax       = response.data.codetax
          this.listPacients      = response.data.pacients
          // Array com apenas os ids dos pacientes
          this.listPacientsPluck = response.data.pacients.map(
            (paciente) => ({
              id: paciente.id,
              nome: paciente.nome
            })
          )
          this.listPrices        = response.data.pricelists
          this.listProfessionals = response.data.professionals
          this.listProfessionalsPluck = filterActiveProfessionals(response.data.professionals).map(
            (professional) => mapProfessionalOption(professional)
          )
          this.listSpecialties    = response.data.specialtys
          this.tiposPagamento    = response.data.tiposPagamento
          Swal.close()
          return true
        }
      } catch (error) {
        console.log(error.response)

        if (error.response.status != 403) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: "Acesso negado",
            text: `Erro: ${error.response.data.message}\n.`,
          });
        }
      } finally {
        Swal.close();
      }
    },
    async getData() {
      Swal.close()
      Swal.fire({
        title: "Aguarde",
        text: "Carregando Atendimentos...",
        allowOutsideClick: false,
        showConfirmButton:false,
        willOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await http.get(`/atendimento?empresa_id=${this.currentEmpresa.id}`)
          if (response.status === 200) {
            this.atendimentos = response.data
            this.oldAtendimentos = this.atendimentos
            Swal.close()
            return this.atendimentos
          }
      } catch (error) {
        console.log(error)
        this.showWarning(error.response.data)
      } finally {
        Swal.close()
      }
    },
    onFilters(params) {
      this.filtering = true
      let promisse = this.atendimentoController.doGet(params)
      promisse.then((response) => {
        this.atendimentos = response.data
        this.oldAtendimentos = this.atendimentos
        this.showSuccess("Filtros aplicados com sucesso!")
        this.filtering = false
      })
      .catch((error) => {
        this.showWarning(error.response.data)
      })
      .finally(() => {
        // this.filtering = false
      })
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    changeHomeTitle(newTitle) {
      this.titleBody = newTitle;
    },
    back() {
      this.inserindo = false
      this.editando = false
      this.wizardIn = false
      this.wizardMultiAgendas = false
    },
    openMultiAgendasWizard() {
      this.wizardIn = false
      this.wizardMultiAgendas = !this.wizardMultiAgendas
    },
    onLoader() {
      if (document.getElementById("preloader").style.display === "none") {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      }
    },
    offLoader() {
      if (document.getElementById("preloader").style.display === "block") {
        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      }
    },
    wizar() {
      this.wizardMultiAgendas = false
      this.wizardIn = !this.wizardIn
    },
    insert() {
      this.inserindo = !this.inserindo
    },
    edit(value) {
      this.currentAtendimento = value
      this.editando = true
    },
    getErrorMessage(error, fallback = "Erro inesperado.") {
      const data = error?.response?.data

      if (typeof data === "string") {
        return data
      }

      if (data?.message) {
        return data.message
      }

      if (data?.error) {
        return data.error
      }

      if (data?.errors && typeof data.errors === "object") {
        const messages = Object.values(data.errors)
          .flat()
          .filter(Boolean)

        if (messages.length > 0) {
          return messages.join("\n")
        }
      }

      if (error?.message) {
        return error.message
      }

      return fallback
    },
    // Method show SweetAlert Warning timer 5 seconds
    // Param: message = String
    showWarning(message) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: message,
        timer: 5000,
        showConfirmButton: false,
      });
      return true;      
    },
    // Method show SweetAlert Success timer 5 seconds
    // Param: message = String
    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: message,
        timer: 2000,
        showConfirmButton: false,
      });
      return true;
    },
    // Modal SweetAlert definir parâmetros atendimentoController.evolutionCodeTaxPdf
    // SweetAlert with request to generate report
    showEvolutionCodeTaxPdf() {
      try {
        // Carregar valores salvos do localStorage
        const savedDateIni = localStorage.getItem('evolutionCodeTax_date_ini') || '';
        const savedDateEnd = localStorage.getItem('evolutionCodeTax_date_end') || '';
        
        const result = Swal.fire({
          title: "Relatório Faturamento x Fiscal",
          text: "Relatório de atendimentos realizados com código de Fiscal",
          allowOutsideClick: false,
          showLoaderOnConfirm: true,
          confirmButtonText: "Visualizar",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          html: `
            <div class="row">
              <div class="col-md-6">
                <label for="date_ini">Data Inicial</label>
                <input value="${savedDateIni}" type="date" id="date_ini" class="form-control" required>
              </div>
              <div class="col-md-6">
                <label for="date_end">Data Final</label>
                <input value="${savedDateEnd}" type="date" id="date_end" class="form-control" required>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            return new Promise((resolve) => {
              const dateIni = document.getElementById("date_ini").value;
              const dateEnd = document.getElementById("date_end").value;
              
              // Salvar valores no localStorage
              localStorage.setItem('evolutionCodeTax_date_ini', dateIni);
              localStorage.setItem('evolutionCodeTax_date_end', dateEnd);
              
              this.params.date_ini = dateIni;
              this.params.date_end = dateEnd;
              this.atendimentoController.evolutionCodeTaxPdf(this.params).then(() => {
                resolve();
              });
            });
          },
        });

        if (result.isConfirmed) {
          this.makeToast("success", "Relatório gerado com sucesso!");
        }
      } catch (error) {
        this.makeToast("danger", error.response.data.message);
      }
    },
    // Modal SweetAlert definir parâmetros atendimentoController.gerarRelatorioAtendimentos
    // SweetAlert with request to generate report
    showAtedimentReport() {
      try
      {
        // Cria um div para montar o componente
        const wrapper = document.createElement("div");
        // Mostra o componente AtendimentosRealizados
        const componentAtendimentosRealizados = new (Vue.extend(AtendimentosRealizados))({
          propsData: {
            listProfessionals: this.listProfessionals,
            listPacients: this.listPacients,
            listSpecialties: this.listSpecialties,
            currentParams: this.params
          }
        }).$mount();
        // Adiciona o componente ao div
        wrapper.appendChild(componentAtendimentosRealizados.$el);

        const result = Swal.fire({
          title: "Relatório - Atendimentos realizados",
          allowOutsideClick: false,
          showLoaderOnConfirm: true,
          confirmButtonText: "Visualizar",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          html: wrapper,
          preConfirm: () => {
            return new Promise((resolve) => {
              this.atendimentoController.gerarRelatorioAtendimentos(this.params).then(() => {
                resolve();
              }).catch((error) => {
                console.log(error);
                // Se contem "status code 403", mostra Toast com "Erro de permissão"
                if (error.includes("status code 403")) {
                  this.makeToast("danger", "O usuário logado não tem permissão para gerar o relatório");
                } else {
                  this.makeToast("danger", error);
                }
                resolve();
              });
            });
          },
        });

        if (result.isConfirmed) {
          this.makeToast("success", "Relatório gerado com sucesso!");
        }
      } catch (error) {
        this.makeToast("danger", error.response.data.message);
      }
    },
    async showPatientReport() {
      try {
        await this.reportController.showPatientReport();
      } catch (error) {
        console.error('Erro ao gerar relatório:', error);
        this.makeToast("danger", error.response?.data?.message || 'Erro ao gerar relatório');
      }
    },
    async showAmountTransfer() {
      try {
        await this.reportController.showAmountTransfer();
      } catch (error) {
        console.error('Erro ao gerar relatório de repasse:', error);
        this.makeToast("danger", error.response?.data?.message || 'Erro ao gerar relatório');
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="titleBody" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body pb-0">
            <div class="row">
              <div class="col-12 text-md-left" v-if="isHide">
                <b-button
                  v-if="isHide"
                  v-b-toggle="'collapse-filtrers'"
                  variant="primary"
                  class="mb-3 ml-3 mt-3"
                >
                  <i class="fas fa-filter"></i> Filtros
                </b-button>
                <b-dropdown v-bind:id="'dropdown-relatorios'" class="m-md-2" v-if="isHide && permission">
                  <template #button-content>
                    <i data-v-6289eca4="" class="bx ri-menu-line"></i> Relatórios
                  </template>
                  <b-dropdown-item @click="showPatientReport()">
                    <i class="fas fa-file-invoice"></i>
                    Rel. Emissão NFS-e
                  </b-dropdown-item>
                  <b-dropdown-item @click="showAtedimentReport(params)">
                    <i class="fas fas fa-file-contract"></i>
                    Rel. Evoluções
                  </b-dropdown-item>
                  <b-dropdown-item @click="showEvolutionCodeTaxPdf(params)">
                    <i class="fas fa-file-pdf"></i>
                    Rel. Fiscal
                  </b-dropdown-item>
                  <b-dropdown-item @click="showAmountTransfer()">
                    <i class="fas fa-file-invoice-dollar"></i>
                    Rel. Repasse
                  </b-dropdown-item>
                </b-dropdown>
                <button
                  @click="wizar()"
                  type="button"
                  class="btn btn-outline-success mb-3 ml-3 mt-3"
                >
                  <i class="fas fa-rocket"></i>
                  Incluir novo atendimento
                </button>
                <button
                  @click="openMultiAgendasWizard()"
                  type="button"
                  class="btn btn-outline-info mb-3 ml-2 mt-3"
                >
                  <i class="fas fa-calendar-plus"></i>
                  Incluir multi-agendas
                </button>
              </div>
              <div class="col-12 text-md-right" v-if="!isHide">
                <button
                  @click="back()"
                  class="btn btn-outline-primary"
                >
                  Voltar
                </button>
              </div>
              <div class="col-12">
                <b-collapse id="collapse-filtrers" class="mt-1" v-if="isHide">
                  <b-card>
                    <div class="row">
                      <div class="col-6">
                        <b-form-group label="Por Pacientes:">
                          <Multiselect
                            v-model="params.pacients"
                            :options="listPacientsPluck"
                            label="nome"
                            track-by="id"
                            :multiple="true"
                            :taggable="true"
                            :close-on-select="false"
                          />
                        </b-form-group>
                      </div>
                      <div class="col-6">
                        <b-form-group label="Por Profissionais:">
                          <Multiselect
                            v-model="params.professionals"
                            :options="listProfessionalsPluck"
                            label="name"
                            track-by="id"
                            :multiple="true"
                            :taggable="true"
                            :close-on-select="false"
                          >
                            <template #option="{ option }">
                              <span :class="{ 'professional-inactive': !isProfessionalActive(option) }">
                                {{ professionalFilterLabel(option) }}
                              </span>
                            </template>
                            <template #tag="{ option, remove }">
                              <span class="multiselect__tag">
                                <span :class="{ 'professional-inactive': !isProfessionalActive(option) }">
                                  {{ professionalFilterLabel(option) }}
                                </span>
                                <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
                              </span>
                            </template>
                          </Multiselect>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <b-button variant="primary" @click="onFilters(params)">
                          <i class="fas fa-database"></i> Aplicar filtros
                        </b-button>
                        <p v-for="paciente in params.pacients" :key="paciente.id" class="mt-3">
                          {{ paciente.nome }}
                        </p>
                      </div>
                    </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </div>
          <div class="card-body pt-3" v-if="!isHide">
            <Wizard
              v-if="wizardIn"
              :currentUser="currentUser"
              :currentEmpresa="currentEmpresa"
              :listAgreements="listAgreements"
              :listApproachs="listApproachs"
              :listCodesTax="listCodeTax"
              :listPacients="listPacients"
              :listPrices="listPrices"
              :listProfessionals="listProfessionals"
              :listSpecialties="listSpecialties"
              :listTiposPagamento="tiposPagamento"
              @newTitle="changeHomeTitle"
              @doPost="doPost"
              @back="back"
            >
            </Wizard>
            <MultiAgendasWizard
              v-if="wizardMultiAgendas"
              :currentUser="currentUser"
              :currentEmpresa="currentEmpresa"
              :listAgreements="listAgreements"
              :listApproachs="listApproachs"
              :listCodeTax="listCodeTax"
              :listPacients="listPacients"
              :listPrices="listPrices"
              :listProfessionals="listProfessionals"
              :listSpecialties="listSpecialties"
              :listTiposPagamento="tiposPagamento"
              @newTitle="changeHomeTitle"
              @doPostLote="doPostLote"
              @back="back"
            />
            <Insert
              v-if="inserindo"
              :currentUser="currentUser"
              :currentEmpresa="currentEmpresa"
              @newTitle="changeHomeTitle"
              @doPost="doPost"
              @back="back"
              :listApproachs="listApproachs"
              :listAgreements="listAgreements"
              :listCodesTaxs="listCodeTax"
              :listPacients="listPacients"
              :listPrices="listPrices"
              :listProfessionals="listProfessionals"
              :listResponsibles="listResponsibles"
              :listSpecialties="listSpecialties"
              :tiposPagamento="tiposPagamento"
            />
            <Edit
              v-if="editando"
              :currentUser="currentUser"
              :currentEmpresa="currentEmpresa"
              :currentAtendimento="currentAtendimento"
              @newTitle="changeHomeTitle"
              @doPut="doPut"
              @back="back"
              :listAgreements="listAgreements"
              :listApproachs="listApproachs"
              :listCodestaxs="listCodeTax"
              :listPacients="listPacients"
              :listPrices="listPrices"
              :listProfessionals="listProfessionals"
              :listSpecialties="listSpecialties"
              :tiposPagamento="tiposPagamento"
            />
          </div>
          <List
            v-if="isHide && !filtering"
            :currentUser="currentUser"
            :currentEmpresa="currentEmpresa"
            :listAtendimentos="atendimentos"
            :hide="isHide"
            @newTitle="changeHomeTitle"
            @edit="edit"
            @doDelete="doDelete"
            @updateSchedules="doUpdateSchedules"
            @finishAtendimento="finishAtendimento"
            @onFilters="onFilters"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>
